import { useQuery } from '@tanstack/react-query'
import { fetchOnboardingAdvisoryStatus } from '../../repository/misc'
import { EliteLandingPageLoader } from '../../components/elite/landing-page/EliteLandingPageLoader'
import { EliteOnboardingStatusResponse } from '../../types/misc.types'
import { Navigate, useSearchParams } from 'react-router-dom'

export const EliteLandingPageRB = () => {
  const [searchParams] = useSearchParams()
  const { data, isLoading } = useQuery<any, Error>({
    queryKey: ['ONBOARDING_ADVISORY_STATUS'],
    queryFn: fetchOnboardingAdvisoryStatus,
    retry: 1,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true
  })

  const isRedirectToRB = () => {
    const dataCopy = data?.data as EliteOnboardingStatusResponse
    const numberOfFundsToRebalance = dataCopy?.numberOfFundsToRebalance ?? 0
    return numberOfFundsToRebalance > 0
  }

  if (isLoading) return <EliteLandingPageLoader />

  const params = new URLSearchParams(searchParams)
  const queryString = params?.toString() || ''

  return isRedirectToRB() ? (
    <Navigate to={`/elite/rb?${queryString}`} replace />
  ) : (
    <Navigate to={`/elite/v5?${queryString}`} replace />
  )
}
